import { render, staticRenderFns } from "./Helps.vue?vue&type=template&id=85a4256a&scoped=true&"
import script from "@/views/Helps/Helps.ts?vue&type=script&lang=ts&"
export * from "@/views/Helps/Helps.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Helps/helps.scss?vue&type=style&index=0&id=85a4256a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a4256a",
  null
  
)

export default component.exports